import { CancelPageProps } from 'src/pages/CancelPage/index'
import styled from 'styled-components'
import icon_noti from 'src/assets/images/cancel/cancel_notice_icon.png'
import {
  Noto_body1_b16,
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body2_r14,
  Noto_body3_r12,
  Noto_DisPlay2_b24,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import useLoginDetector from 'src/hooks/useLoginDetector.hook'

const CancelPageView = ({ cancelHandler, isCancelSubmitPending }: CancelPageProps) => {
  const { isLogin } = useLoginDetector()
  return (
    <S.CancelContainer $option="flex_column_space_between">
      <Container $option="flex_column">
        <S.CancelTopContents $option="flex_column" $row_gap="10px">
          <S.CancelNotiImg src={icon_noti} alt="테스트" />
          <Typography $fontStyle={Noto_DisPlay2_b24}>해지하기 전 확인해주세요.</Typography>
        </S.CancelTopContents>
        <S.CancelMidContents $option="flex_column" $row_gap="18px">
          <Typography $fontStyle={Noto_body1_r16}>· 핫딜 참여 및 상시할인 혜택 중단</Typography>
          <Typography $fontStyle={Noto_body1_r16}>· 미사용 쿠폰을 확인하세요.</Typography>
          <Typography $fontStyle={Noto_body1_r16}>
            · 서비스해지 시,{' '}
            <Typography $fontStyle={Noto_body1_b16} $color={'var(--red-50)'}>
              1개월간 재가입이 제한
            </Typography>
            됩니다.
          </Typography>
          <Typography $fontStyle={Noto_body1_r16}>
            ·{' '}
            <Typography $fontStyle={Noto_body1_b16} $color={'var(--red-50)'}>
              1년 이내에 가입과 해지를 반복
            </Typography>
            할 경우,{' '}
            <Typography $fontStyle={Noto_body1_b16} $color={'var(--red-50)'}>
              서비스 가입이 제한
            </Typography>
            될 수 있습니다.
          </Typography>
          <Typography $fontStyle={Noto_body1_r16}>
            · 구매내역에서 구매한 쿠폰 내역을 저장하지 않고 해지하는 경우, 재가입 시 쿠폰 내역은
            복원되지 않습니다.
          </Typography>
          <S.CancelPrimaryNoti $fontStyle={Noto_body2_r14}>
            기존에 구매한 쿠폰은 해지 후에도 전송받은
            <Typography $fontStyle={Noto_body2_b14}>MMS이미지로 사용</Typography>할 수 있습니다.
          </S.CancelPrimaryNoti>
          <S.CancelPrimaryNoti $fontStyle={Noto_body2_r14}>
            이미지가 없는 경우
            <Typography $fontStyle={Noto_body2_b14}>
              [마이페이지] &gt;&nbsp;[구매내역] &gt;&nbsp; [쿠폰상세]
            </Typography>
            화면에서 받으실 수 있습니다.
          </S.CancelPrimaryNoti>
        </S.CancelMidContents>
      </Container>
      <S.CancelBottomContents $option="flex_column" $row_gap="10px">
        <Typography $fontStyle={Noto_body3_r12} $color={'var(--black-70)'}>
          상기 내용을 확인하였으며, 서비스 해지를 진행하겠습니다.
        </Typography>
        <Button
          option={ButtonOption3('active')}
          onClickFn={cancelHandler}
          disabled={!isLogin || isCancelSubmitPending}
        >
          서비스 해지하기
        </Button>
      </S.CancelBottomContents>
    </S.CancelContainer>
  )
}
export default CancelPageView

const S = {
  CancelContainer: styled(Container)`
    width: calc(100% - 40px);
    text-align: center;
    flex: 1;
  `,
  CancelPrimaryNoti: styled(Typography)`
    background-color: var(--black-2);
    padding: 20px;
    border-radius: 12px;
  `,
  CancelTopContents: styled(Container)`
    margin: 30px auto;
  `,
  CancelNotiImg: styled.img`
    margin: 0 auto;
    width: 40px;
    height: 40px;
  `,
  CancelMidContents: styled(Container)`
    text-align: left;
  `,
  CancelBottomContents: styled(Container)`
    padding-top: 30px;
    padding-bottom: 72px;
  `,
}
